// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSelfStudyDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SelfStudyDTO from '../models/SelfStudyDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    id: 'id',
}

interface Result extends ResultDTO {
    selfStudy: SelfStudyDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            selfStudy: null,
        },
        initValues);
    },
    selfStudy: 'selfStudy',
}

export { Request, Result };